export const SELECT_ALL_NODE_ID = 'select_all';
//# sourceMappingURL=BKJPillDropdown.constants.js.map